import { Reveal } from "@/components/Reveal";

export const SectionHeader = ({ eyebrow, title, text, align = "left", light = false, testId }) => (
  <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`} data-testid={testId}>
    {eyebrow && <p className={`eyebrow ${light ? "!text-[var(--lime)]" : ""}`}>{eyebrow}</p>}
    <h2 className={`font-display mt-4 text-3xl font-bold leading-[1.02] sm:text-4xl lg:text-5xl ${light ? "text-white" : "text-[var(--ink)]"}`}>
      {title}
    </h2>
    {text && <p className={`mt-5 text-base leading-relaxed md:text-lg ${light ? "text-white/70" : "text-[var(--ink-2)]"}`}>{text}</p>}
  </Reveal>
);
